import { graphql } from '@gql';

export const CREATE_COMPONENT_CREATE_REQUEST = graphql(`
    mutation CreateComponentCreateRequest(
        $input: CreateComponentCreateRequestRawInput!
    ) {
        createComponentCreateRequest(input: $input) {
            request {
                ...CreateComponentRequestFragment
            }
            statusTransitions {
                ...CreateComponentRequestStatusTransition
            }
        }
    }
`);

export const CHANGE_COMPONENT_CREATE_REQUEST_STATUS = graphql(`
    mutation ChangeComponentCreateRequestStatus(
        $input: ReviewComponentCreateRequestRawInput!
    ) {
        reviewComponentCreateRequest(input: $input) {
            ...CreateComponentRequestFragment
        }
    }
`);

export const UPDATE_COMPONENT_CREATE_REQUEST = graphql(`
    mutation UpdateComponentCreateRequest(
        $id: ID!
        $input: UpdateComponentCreateRequestRawInput!
    ) {
        updateComponentCreateRequest(id: $id, input: $input) {
            ...CreateComponentRequestFragment
        }
    }
`);
